<section class="create-lease-agreement-invoices">
  @if (!previewDataContext) {
    <div class="header">
      <h1>{{ 'SEND_INVOICES_FORM.HEADERSINGLE' | translate }}</h1>
      <button class="btn btn-active btn-list-header" (click)="preview()" [disabled]="form.disabled">
        {{ 'COMMON.CONTINUE' | translate }}
      </button>
    </div>
  }

  @if (initialized) {
    @if (!moduleActive) {
      <div class="create-lease-agreement-invoices__module-note astral-content-width astral-section-surface">
        {{ 'SEND_INVOICES_FORM.MODULE_STATE_TEXT' | translate }} <a routerLink="/dashboard/profile">{{ 'HERE_TEXT' | translate }}</a
        >.
      </div>
    }
    @if (moduleActive) {
      @if (processing) {
        <div class="create-lease-agreement-invoices__content astral-content-width">
          <app-information-block [text]="'SEND_INVOICES_FORM.STATE_TEXT'"></app-information-block>
        </div>
      }
      @if (!processing) {
        @if (!previewDataContext) {
          <div class="create-lease-agreement-invoices__content astral-content-width astral-content-width--with-list-surface astral-stack-l">
            <section class="astral-section-surface astral-section-surface--list-width astral-stack-m">
              <div class="create-lease-agreement-invoices__selection-grid">
                <div class="create-lease-agreement-invoices__period-section astral-stack-m">
                  <app-information-block [text]="'INVOICE.INFORMATION_TEXT.INVOICE_PERIOD_SINGLE'"></app-information-block>
                  <app-multiselect-list-view
                    #rentPeriodList
                    [columnDefinition]="rentPeriodColumnDefinition"
                    [itemsSource]="relevantRentPeriods"
                    [preferencesKey]="'invoice.create-lease-agreement-invoices.list'"
                    [selectAll]="false"
                    >
                  </app-multiselect-list-view>
                  <div class="create-lease-agreement-invoices__period-actions">
                    <astral-button
                      type="button"
                      variant="secondary"
                      size="small"
                      labelKey="INVOICE.LOAD_EARLIER_PERIODS"
                      [disabled]="disableLoadEarlierPeriods"
                      (click)="loadEarlierPeriods()"
                    ></astral-button>
                    <astral-button
                      type="button"
                      variant="secondary"
                      size="small"
                      labelKey="INVOICE.LOAD_LATER_PERIODS"
                      [disabled]="disableLoadLaterPeriods"
                      (click)="loadLaterPeriods()"
                    ></astral-button>
                  </div>
                </div>
                @if (displayInvoiceAddress) {
                  <div class="create-lease-agreement-invoices__address-section">
                    <app-postal-address
                      [group]="invoiceAddressForm"
                      [model]="invoiceAddress"
                      [mandatory]="true"
                      [helpText]="'SEND_INVOICES_FORM.HELP_TEXT.INVOICE_ADDRESS_HEADER'"
                      [title]="'LEASE_AGREEMENT.INVOICE_ADDRESS_HEADER'"
                      [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
                      [showName]="true"
                    ></app-postal-address>
                  </div>
                }
              </div>
            </section>
            <section class="astral-section-surface astral-stack-m">
              <app-file-upload
                [forms]="appendixes"
                [text]="'COMMON.ATTACH_PDF_FILE'"
                [allowedMimeTypes]="mimeTypes"
                buttonVariant="primary"
              ></app-file-upload>
            </section>
            @if (hasJointDebiting) {
              <section class="astral-section-surface astral-section-surface--list-width astral-stack-m">
                <div class="create-lease-agreement-invoices__section-heading">
                  <h4>{{ 'SEND_INVOICES_FORM.JOINT_DEBITING_LIST_HEADER' | translate }}</h4>
                  <astral-popover [helpText]="'SEND_INVOICES_FORM.HELP_TEXT.JOINT_DEBITING_HEADER'"></astral-popover>
                </div>
                <app-multiselect-list-view
                  #contractList
                  [columnDefinition]="contractColumnDefinition"
                  [itemsSource]="contracts"
                  [preferencesKey]="'invoice.create-lease-agreement-invoices.list'"
                  [selectAll]="true"
                  >
                </app-multiselect-list-view>
              </section>
            }
          </div>
        }
        @if (previewDataContext) {
          <div class="create-lease-agreement-invoices__content astral-content-width astral-content-width--with-list-surface astral-stack-l">
            <section class="astral-section-surface astral-section-surface--list-width astral-stack-m create-lease-agreement-invoices__preview">
              <app-preview-invoices [from]="previewFrom" [dataContext]="previewDataContext" [to]="previewTo"></app-preview-invoices>
            </section>
            <div class="create-lease-agreement-invoices__actions">
              @if (canCreate) {
                <astral-button type="button" variant="primary" labelKey="CREATE_BTN" (click)="create()"></astral-button>
              }
              <astral-button type="button" variant="secondary" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
            </div>
          </div>
        }
      }
    }
  }
</section>
